module.exports = __webpack_public_path__ + "static/media/550plus.f18a323e.svg";